import React from 'react';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import { NavigationHeader } from 'components/NavigationHeader';
import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { View, StyleSheet } from 'react-native';
import { theme } from 'lib/theme';
import { Icon, ICONS } from 'components/Icon';
import QRCode from 'react-native-qrcode-svg';
import * as Clipboard from 'expo-clipboard';
import { useDispatch } from 'react-redux';
import {
  doToast,
  eventBarcodeSelected,
  NAVIGATE_MODAL_BACK,
} from 'store/actions';
import { useEsc } from 'hooks/useEsc';
import { useConfirm } from 'hooks/useConfirm';
import { isEngageUrl } from 'service/api/constants';
import { openUrl } from 'lib/riskbase';

export const QRViewerScreen: React.FC<
  ModalScreenProps<ModalScreens.QR_VIEWER>
> = ({ route }) => {
  const dispatch = useDispatch();
  const confirm = useConfirm();

  const { data, deleteKey } = route.params;

  useEsc(() => dispatch(NAVIGATE_MODAL_BACK()));

  if (!data) {
    return null;
  }

  const handleCopyData = async () => {
    await Clipboard.setStringAsync(data);
    dispatch(doToast('QR Data Copied'));
  };

  const handleDelete = () => {
    if (deleteKey) {
      confirm({
        text: 'Do you want to delete the QR code data?',
        confirmText: 'Delete',
        destructive: true,
        onConfirm: () => {
          dispatch(eventBarcodeSelected({ key: deleteKey, data: '' }));
          dispatch(NAVIGATE_MODAL_BACK());
        },
      });
    }
  };

  const qrSize = 280;
  const logoSize = 280 * 0.2;
  const isUrlEngage = isEngageUrl(data);

  return (
    <Page
      contentPaddingTop={0}
      header={
        <NavigationHeader
          heading="QR Code"
          onPressCancelButton={() => dispatch(NAVIGATE_MODAL_BACK())}
          cancelButtonText="Close"
        />
      }
    >
      <View
        style={{
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <View
          style={{ padding: 20, backgroundColor: 'white', borderRadius: 4 }}
        >
          <QRCode
            value={data}
            size={qrSize}
            logoSize={logoSize}
            backgroundColor="white"
            color={isUrlEngage ? theme.colors.green : theme.colors.black}
          />
        </View>
        <View
          style={[
            StyleSheet.absoluteFill,
            { alignItems: 'center', justifyContent: 'center' },
          ]}
        >
          <Icon
            source={ICONS.RBPlectrumWithBorder}
            size={logoSize}
            color={theme.colors.green}
            style={{
              opacity: 0.98,
              shadowOffset: { width: 0, height: 0 },
              shadowColor: isUrlEngage
                ? theme.colors.green
                : theme.colors.black,
              shadowOpacity: 1,
              shadowRadius: 10,
              overflow: 'visible',
            }}
          />
        </View>
      </View>
      <Card style={{ marginBottom: theme.paddingHorizontal }}>
        <CardRow
          value={data}
          actionIcon={ICONS.CopyLight}
          onAction={handleCopyData}
          actionIcon2={ICONS.ArrowUpRightFromSquareLight}
          onAction2={isUrlEngage ? () => openUrl(data) : undefined}
        />
        {!!deleteKey && (
          <CardRow
            label="Delete QR Code Data"
            icon={ICONS.TrashCanLight}
            onPress={handleDelete}
            iconColor={theme.colors.red}
            labelColor={theme.colors.red}
          />
        )}
      </Card>
    </Page>
  );
};
